export default "__VITE_ASSET__BooiMCc5__"